import Animal from "../../components/Nursery/EnvironmentScience/Animal";
import Fruits from "../../components/Nursery/EnvironmentScience/Fruits";
import Vegetables from "../../components/Nursery/EnvironmentScience/Vegetables";
import AnimalMenu from "./Animal";
import VegetablesMenu from "./Vegetables";
import FruitMenu from "./Fruit";
import Plants from "../../components/Nursery/EnvironmentScience/Plants";
import PlantsMenu from "./Plants";
import BodyParts from "../../components/Nursery/EnvironmentScience/BodyParts";
import BodyPartsMenu from "./BodyParts";
import Seasons from "../../components/Nursery/EnvironmentScience/Seasons";
import SeasonsMenu from "./Seasons";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/nursery/environmental-science/animal", title: "Animal", component: Animal, subMenu: AnimalMenu},
    { url: "/nursery/environmental-science/vegetables", title: "Vegetables", component: Vegetables, subMenu: VegetablesMenu},
    { url: "/nursery/environmental-science/fruit", title: "Fruit", component: Fruits, subMenu: FruitMenu},
    // { url: "/nursery/environmental-science/plants", title: "Plants", component: Plants, subMenu: PlantsMenu},
    { url: "/nursery/environmental-science/body-parts", title: "Body Parts", component: BodyParts, subMenu: BodyPartsMenu},
    { url: "/nursery/environmental-science/seasons", title: "Seasons", component: Seasons, subMenu: SeasonsMenu},
];


export default topics;